/**
 * Product Component JavaScript
 * Handles product image gallery functionality and variant selection
 */

document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const mediaItems = document.querySelectorAll('.product-media-item');
  const variantInputs = document.querySelectorAll('.product-variant-item__input');
  const productForm = document.querySelector('form[action*="/cart/add"], form[action*="/cart"], .product-form form');
  
  // Handle image gallery
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const mediaId = this.dataset.mediaId;
      
      // Hide all media items
      mediaItems.forEach(item => {
        item.classList.remove('active');
      });
      
      // Show selected media item
      const selectedMedia = document.querySelector(`[data-media-id="${mediaId}"]`);
      if (selectedMedia) {
        selectedMedia.classList.add('active');
      }
      
      // Update active thumbnail and ARIA states
      thumbnails.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
    });
  });

  // Handle variant selection
  variantInputs.forEach(input => {
    input.addEventListener('change', function() {
      const variantId = this.value;
      
      // Update any hidden select that ReCharge might be watching
      const hiddenSelect = document.querySelector('select[name="id"]');
      if (hiddenSelect) {
        hiddenSelect.value = variantId;
        hiddenSelect.dispatchEvent(new Event('change'));
      }

      // Trigger custom event for ReCharge
      const event = new CustomEvent('variant:changed', {
        detail: { variantId: variantId }
      });
      document.dispatchEvent(event);

      // Update form action if needed
      const form = this.closest('form');
      if (form) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('variant', variantId);
        form.action = currentUrl.toString();
      }

      // Update button pricing for new variant
      updateButtonPricingForVariant(variantId);
    });
  });

  // Function to update button pricing for a specific variant
  function updateButtonPricingForVariant(variantId) {
    const button = document.querySelector('.product-form .btn');
    if (!button) return;

    // Try ReCharge pricing first (existing behavior - unchanged)
    if (window.SubscriptionWidgetConfig?.formattedPrices?.[variantId]) {
      const pricing = window.SubscriptionWidgetConfig.formattedPrices[variantId];

      const buttonComparePrice = button.querySelector('.compare-at-price');
      const buttonCurrentPrice = button.querySelector('.button-original-price');

      // Check if subscription is selected - look for various ReCharge selectors
      const subscriptionSelected = isSubscriptionSelected();

      if (subscriptionSelected) {
        // Show subscription pricing (original price + discounted price)
        if (pricing.unit && buttonComparePrice) {
          buttonComparePrice.textContent = pricing.unit;
          buttonComparePrice.style.display = 'inline';
        }
        if (pricing.discounted && buttonCurrentPrice) {
          buttonCurrentPrice.textContent = pricing.discounted;
        }
      } else {
        // Show one-time pricing (only original price, no strikethrough)
        if (buttonComparePrice) {
          buttonComparePrice.style.display = 'none';
        }
        if (pricing.unit && buttonCurrentPrice) {
          buttonCurrentPrice.textContent = pricing.unit;
        }
      }
      return; // Exit early to preserve existing behavior
    }

    // Fallback: Read from DOM data attributes (new code)
    const variantInput = document.querySelector(`input[name="id"][value="${variantId}"]`);
    if (variantInput) {
      const price = variantInput.dataset.price;
      const compareAtPrice = variantInput.dataset.compareAtPrice;

      const buttonComparePrice = button.querySelector('.compare-at-price');
      const buttonCurrentPrice = button.querySelector('.button-original-price');

      if (buttonCurrentPrice && price) {
        buttonCurrentPrice.textContent = price;
      }

      if (buttonComparePrice) {
        if (compareAtPrice && compareAtPrice !== price && compareAtPrice.trim() !== '') {
          buttonComparePrice.textContent = compareAtPrice;
          buttonComparePrice.style.display = 'inline';
        } else {
          buttonComparePrice.style.display = 'none';
        }
      }
    }
  }

  // Handle form submission to open ReCharge drawer
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Trigger ReCharge drawer opening
        const cartEvent = new CustomEvent('cart:updated', {
          detail: { cart: data }
        });
        document.dispatchEvent(cartEvent);
        
        // Also try to trigger ReCharge's own events
        if (window.ReChargeWidget) {
          window.ReChargeWidget.openCart();
        }
        
        // Fallback: try to find and click ReCharge's cart button
        const rechargeCartButton = document.querySelector('[data-shopify="recharge-cart"], .recharge-cart-button');
        if (rechargeCartButton) {
          rechargeCartButton.click();
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        // Fallback to normal form submission
        this.submit();
      });
    });
  }

  // Function to update pricing based on current selection
  function updateButtonPricingForCurrentSelection() {
    const button = document.querySelector('.product-form .btn');
    if (!button) return;

    const currentVariantId = document.querySelector('input[name="id"]:checked')?.value || 
                             document.querySelector('select[name="id"]')?.value ||
                             document.querySelector('input[name="id"]')?.value;

    if (!currentVariantId || !window.SubscriptionWidgetConfig?.formattedPrices) return;

    const pricing = window.SubscriptionWidgetConfig.formattedPrices[currentVariantId];
    if (!pricing) return;

    const buttonComparePrice = button.querySelector('.compare-at-price');
    const buttonCurrentPrice = button.querySelector('.button-original-price');

    // Check if subscription is selected - look for various ReCharge selectors
    const subscriptionSelected = isSubscriptionSelected();

    if (subscriptionSelected) {
      // Show subscription pricing (original price + discounted price)
      if (pricing.unit && buttonComparePrice) {
        buttonComparePrice.textContent = pricing.unit;
        buttonComparePrice.style.display = 'inline';
      }
      if (pricing.discounted && buttonCurrentPrice) {
        buttonCurrentPrice.textContent = pricing.discounted;
      }
    } else {
      // Show one-time pricing (only original price, no strikethrough)
      if (buttonComparePrice) {
        buttonComparePrice.style.display = 'none';
      }
      if (pricing.unit && buttonCurrentPrice) {
        buttonCurrentPrice.textContent = pricing.unit;
      }
    }
  }

  // Function to check if subscription is currently selected
  function isSubscriptionSelected() {
    // Check for ReCharge radio buttons
    const subscriptionRadio = document.querySelector('input[name="purchaseOption"][value="subscription"]');
    const onetimeRadio = document.querySelector('input[name="purchaseOption"][value="onetime"]');
    
    if (subscriptionRadio && onetimeRadio) {
      return subscriptionRadio.checked;
    }

    // Check for ReCharge button states
    const subscriptionButton = document.querySelector('[data-purchase-option="subscription"]');
    const onetimeButton = document.querySelector('[data-purchase-option="onetime"]');
    
    if (subscriptionButton && onetimeButton) {
      return subscriptionButton.classList.contains('selected') || 
             subscriptionButton.getAttribute('aria-pressed') === 'true';
    }

    // Check for ReCharge widget state - handle Shadow DOM
    const rechargeWidget = document.querySelector('recharge-subscription-widget');
    
    if (rechargeWidget && rechargeWidget.shadowRoot) {
      // Look for specific ReCharge selectors in shadow DOM first (most reliable)
      const subscriptionElements = rechargeWidget.shadowRoot.querySelectorAll('[data-purchase-option="subscription"], .subscription-option, input[value="subscription"], [part*="subscription"]');
      const onetimeElements = rechargeWidget.shadowRoot.querySelectorAll('[data-purchase-option="onetime"], .onetime-option, input[value="onetime"], [part*="onetime"]');
      
      for (let element of subscriptionElements) {
        if (element.classList.contains('selected') || 
            element.getAttribute('aria-pressed') === 'true' ||
            element.checked) {
          return true;
        }
      }
      
      for (let element of onetimeElements) {
        if (element.classList.contains('selected') || 
            element.getAttribute('aria-pressed') === 'true' ||
            element.checked) {
          return false;
        }
      }
      
      // Only check text content if we have clear purchase option elements
      const purchaseOptionElements = rechargeWidget.shadowRoot.querySelectorAll('[data-purchase-option], .purchase-option, [part*="purchase-option"]');
      if (purchaseOptionElements.length > 0) {
        for (let element of purchaseOptionElements) {
          const text = element.textContent?.toLowerCase().trim() || '';
          const className = element.className?.toLowerCase() || '';
          const ariaPressed = element.getAttribute('aria-pressed');
          const isSelected = element.classList.contains('selected') || element.classList.contains('active');
          const isChecked = element.checked;
          
          // Only return true if we have a clear subscription selection
          if ((text.includes('subscription') || className.includes('subscription')) && 
              (isSelected || ariaPressed === 'true' || isChecked)) {
            return true;
          }
          
          // Only return false if we have a clear one-time selection
          if ((text.includes('one-time') || text.includes('onetime') || className.includes('onetime')) && 
              (isSelected || ariaPressed === 'true' || isChecked)) {
            return false;
          }
        }
      }
    }

    // Check if ReCharge widget exists but we couldn't determine selection
    // This likely means the widget is still loading or using a different structure
    if (rechargeWidget) {
      // Default to subscription if ReCharge widget exists (ReCharge typically defaults to subscription)
      return true;
    }

    // Default to one-time purchase only if no ReCharge widget is present
    return false;
  }

  // Handle dynamic price updates from ReCharge
  function updateButtonPricing() {
    const button = document.querySelector('.product-form .btn');
    if (!button) return;

    // Initialize button pricing display
    const buttonComparePrice = button.querySelector('.compare-at-price');
    const buttonCurrentPrice = button.querySelector('.button-original-price');
    
    // Show compare-at price if it exists and is different from current price
    if (buttonComparePrice && buttonComparePrice.textContent.trim() && 
        buttonComparePrice.textContent.trim() !== buttonCurrentPrice.textContent.trim()) {
      buttonComparePrice.style.display = 'inline';
    }

    // Listen for ReCharge price updates
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Look for ReCharge price elements
          const rechargeOriginalPrice = document.querySelector('[part="rc-purchase-option__original-price"]');
          const rechargeCurrentPrice = document.querySelector('[part="rc-purchase-option__price"]');
          
          if (rechargeOriginalPrice || rechargeCurrentPrice) {
            // Update button pricing
            const buttonComparePrice = button.querySelector('.compare-at-price');
            const buttonCurrentPrice = button.querySelector('.button-original-price');
            
            // Update compare at price if available
            if (rechargeOriginalPrice && buttonComparePrice) {
              const newComparePrice = rechargeOriginalPrice.textContent.trim();
              if (newComparePrice && newComparePrice !== buttonCurrentPrice.textContent.trim()) {
                buttonComparePrice.textContent = newComparePrice;
                buttonComparePrice.style.display = 'inline';
              }
            }
            
            // Update current price if available
            if (rechargeCurrentPrice && buttonCurrentPrice) {
              const newCurrentPrice = rechargeCurrentPrice.textContent.trim();
              if (newCurrentPrice && newCurrentPrice !== buttonCurrentPrice.textContent) {
                buttonCurrentPrice.textContent = newCurrentPrice;
              }
            }
          }
        }
      });
    });

    // Observe ReCharge widget area
    const rechargeWidget = document.querySelector('.recharge-subscription-widget, [data-shopify="recharge-subscriptions"]');
    
    if (rechargeWidget) {
      observer.observe(rechargeWidget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['part', 'class', 'aria-pressed', 'data-purchase-option']
      });
    }

    // Listen for ReCharge events and global events
    document.addEventListener('recharge:price:updated', function(e) {
      if (e.detail && e.detail.price) {
        const buttonCurrentPrice = button.querySelector('.button-original-price');
        if (buttonCurrentPrice) {
          buttonCurrentPrice.textContent = e.detail.price;
        }
      }
      if (e.detail && e.detail.comparePrice) {
        const buttonComparePrice = button.querySelector('.compare-at-price');
        if (buttonComparePrice) {
          buttonComparePrice.textContent = e.detail.comparePrice;
          buttonComparePrice.style.display = 'inline';
        }
      }
    });

    // Listen for any custom events that might be fired
    document.addEventListener('variant:changed', function(e) {
      updateButtonPricingForCurrentSelection();
    });

    // Use ReCharge's pricing configuration
    if (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.formattedPrices) {
      // Get current variant ID
      const currentVariantId = document.querySelector('input[name="id"]:checked')?.value || 
                               document.querySelector('select[name="id"]')?.value ||
                               document.querySelector('input[name="id"]')?.value;
      
      if (currentVariantId && window.SubscriptionWidgetConfig.formattedPrices[currentVariantId]) {
        updateButtonPricingForCurrentSelection();
      }
    }

    // Add event listeners for ReCharge selection changes
    function addReChargeSelectionListeners() {
      
      // Listen for radio button changes
      document.addEventListener('change', function(e) {
        if (e.target.name === 'purchaseOption') {
          setTimeout(updateButtonPricingForCurrentSelection, 100);
        }
      });

      // Listen for button clicks in ReCharge widget
      document.addEventListener('click', function(e) {
        // Check if click is inside ReCharge widget
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        let isReChargeClick = false;
        
        if (rechargeWidget) {
          // Check if click is on the widget itself or inside its shadow DOM
          // Use composedPath() to get the actual event path including shadow DOM
          const path = e.composedPath();
          isReChargeClick = path.includes(rechargeWidget);
        }
        
        if (isReChargeClick) {
          setTimeout(updateButtonPricingForCurrentSelection, 100);
        }
      });

      // Listen for attribute changes on ReCharge elements
      const rechargeObserver = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && 
              (mutation.attributeName === 'class' || 
               mutation.attributeName === 'aria-pressed' || 
               mutation.attributeName === 'data-purchase-option')) {
            shouldUpdate = true;
          }
        });
        if (shouldUpdate) {
          updateButtonPricingForCurrentSelection();
        }
      });

      // Observe ReCharge widget for selection changes
      const rechargeWidget = document.querySelector('recharge-subscription-widget');
      if (rechargeWidget) {
        
        // Observe the main widget
        rechargeObserver.observe(rechargeWidget, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class', 'aria-pressed', 'data-purchase-option']
        });
        
        // Also observe inside shadow DOM if available
        if (rechargeWidget.shadowRoot) {
          rechargeObserver.observe(rechargeWidget.shadowRoot, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class', 'aria-pressed', 'data-purchase-option', 'part']
          });
        }
      }
      
      // Add manual test function to window for debugging
      window.testReChargePricing = function() {
        updateButtonPricingForCurrentSelection();
      };
      
      // Also listen for any ReCharge-specific events
      document.addEventListener('recharge:selection:changed', function(e) {
        updateButtonPricingForCurrentSelection();
      });
      
      // Listen for any custom events from ReCharge
      window.addEventListener('message', function(e) {
        if (e.data && (e.data.type === 'recharge-selection-changed' || e.data.type === 'recharge-price-update')) {
          updateButtonPricingForCurrentSelection();
        }
      });
    }

    // Initialize ReCharge selection listeners
    addReChargeSelectionListeners();
  }

  // Initialize dynamic pricing
  updateButtonPricing();
}); 